import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const MarketOverviewRouter: Array<RouteRecordRaw> = [
  {
    path: '/marketoverview',
    component: Layout,
    redirect: '/marketoverview/index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/market-overview/index.vue'),
        name: 'Marketoverview',
        meta: {
          title: 'Marketoverview',
          icon: '#iconguide'
        }
      }
    ]
  }
]

export default MarketOverviewRouter
